import { render, staticRenderFns } from "./CriteriaGroupsList.vue?vue&type=template&id=d296b074&scoped=true"
import script from "./CriteriaGroupsList.vue?vue&type=script&lang=js"
export * from "./CriteriaGroupsList.vue?vue&type=script&lang=js"
import style0 from "./CriteriaGroupsList.vue?vue&type=style&index=0&id=d296b074&prod&lang=css"
import style1 from "./CriteriaGroupsList.vue?vue&type=style&index=1&id=d296b074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d296b074",
  null
  
)

export default component.exports